import React from "react";
import { Grid } from "@mui/material";
import "./css/reusableBanner.css";
import ButtonReusable from "../buttons/ButtonReusable";
import DialogReusable from "../dialog/DialogReusable";

const BannerReusable = (props) => {
  return (
    <>
      <Grid
        container
        columns={{ xs: 12, sm: 12, md: 12, lg: 12 }}
        columnSpacing={{ xs: 1, sm: 2, md: 3, lg: 3 }}
        rowGap={1}
        justifyContent="center"
        className="reusable_main_container"
      >
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          lg={12}
          className="reusable_banner_container"
        >
          <img
            src={props.banner_image}
            alt="services_banner_image"
            className="reusable_img_banner"
          />
          <p className="shadow-text">MODERN</p>
          <h3 className="banner_tagline">{props.tagline}</h3>
          <div className="contact-buttons">
            <ButtonReusable
              buttonName="contact us"
              size="small"
              backgroundColor="#ff5e14"
              padding="8px 16px"
              color="white"
            />
            <ButtonReusable
              buttonName="Inquire Now"
              size="small"
              backgroundColor="#06253b"
              padding="8px 16px"
              color="white"
              onClick={props.handleDialog}
            />
          </div>
        </Grid>
      </Grid>
    </>
  );
};

export default BannerReusable;
